export function a() {
  const v10237 = typeof WeakSet == "function";
  const v10238 = v10237 ? new WeakSet() : [];
  return [function (p12851) {
    if (v10237) {
      return !!v10238.has(p12851) || (v10238.add(p12851), false);
    }
    for (let vLN01639 = 0; vLN01639 < v10238.length; vLN01639++) {
      const v10239 = v10238[vLN01639];
      if (v10239 === p12851) {
        return true;
      }
    }
    v10238.push(p12851);
    return false;
  }, function (p12852) {
    if (v10237) {
      v10238.delete(p12852);
    } else {
      for (let vLN01640 = 0; vLN01640 < v10238.length; vLN01640++) {
        if (v10238[vLN01640] === p12852) {
          v10238.splice(vLN01640, 1);
          break;
        }
      }
    }
  }];
}